import { StatusPill, type StatusTone } from '@bb/ui';
import type { TranslationStatus } from './localization.ts';

export const TRANSLATION_STATUS_LABELS: Record<TranslationStatus, string> = { missing: 'Missing', draft: 'Draft', ready: 'Ready' };
const TONES: Record<TranslationStatus, StatusTone> = { missing: 'warning', draft: 'info', ready: 'success' };

/**
 * Translation status of one locale of a message (BB-55): `missing` — users get the fallback; `draft` — sent, still
 * being reviewed; `ready` — reviewed, and publishing checks that every text field is filled (`incomplete` when not).
 */
export function TranslationStatusBadge({ status, incomplete = false }: { status: TranslationStatus; incomplete?: boolean }) {
  if (status === 'ready' && incomplete) return <StatusPill tone="danger">Ready, incomplete</StatusPill>;
  return <StatusPill tone={TONES[status]}>{TRANSLATION_STATUS_LABELS[status]}</StatusPill>;
}
